import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DimensionFormTypes, SettingsFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { AddNewDimensionFormContainerProps } from "models/propTypes/dimensionPropTypes";
//#endregion
//#region components
import AddNewDimensionForm from "../dimensions/addNewForm";
import { useDimensionService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const AddNewDimensionFormContainer: ForwardRefRenderFunction<FormHandles, AddNewDimensionFormContainerProps> = (
  props,
  ref
) => {
  const dimensionService = useDimensionService();
  const validationSchema = Yup.object<DimensionFormTypes.AddDimension>({
    name: Yup.string().required(TranslationKeys.Validations.Required),
    shortName: Yup.string().required(TranslationKeys.Validations.Required),
    isActive: Yup.boolean(),
    dimensionTypeId: Yup.string(),
  });

  const defaultValues: DimensionFormTypes.AddDimension = {
    name: props.name ?? "",
    shortName: props.shortName ?? "",
    isActive: props.isActive ?? true,
    dimensionTypeId: props.dimensionTypeId,
  };

  const handleSubmit = async (values: SettingsFormTypes.BaseDimension) => {
    const dimension: WintSuperkollAPIModel.DimensionItem = {
      name: values.name,
      id: props.id,
      canRemove: values.canRemove,
      isActive: values.isActive,
      shortName: values.shortName,
    };

    if (props?.id !== undefined) {
      await dimensionService.updateDimensionItem(props.id, {
        name: values.name,
        shortName: values.shortName,
        active: values.isActive,
      });
    } else {
      await dimensionService
        .createDimensionItem({
          name: values.name,
          shortName: values.shortName,
          active: values.isActive,
          dimensionTypeId: props.dimensionTypeId,
        })
        .then((res) => {
          dimension.id = res.data;
          dimension.canRemove = true;
        });
    }
    return dimension;
  };

  return (
    <AddNewDimensionForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
      isEdit={!!props.id}
    />
  );
};

export default forwardRef(AddNewDimensionFormContainer);
